var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Icon from "@alife/next-icon";
import { ChatList } from "@alife/simple-ui";
import MessageItem from "../components/message-item";
import { formatMessage } from "./formatMessage";
import { defaultLocale } from "../utils/defaultLocale";
import { formatters } from "../utils/card";
export var TimeThreshold = 1000 * 60 * 5;
var MessageContent = (function (_super) {
    __extends(MessageContent, _super);
    function MessageContent(props) {
        var _this = _super.call(this, props) || this;
        _this.localeMerged = {};
        var _a = props.locale, locale = _a === void 0 ? {} : _a;
        _this.localeMerged = Object.assign({}, defaultLocale, locale);
        return _this;
    }
    MessageContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, isLoading = _a.isLoading, _b = _a.messageList, messageList = _b === void 0 ? [] : _b, loadMore = _a.loadMore, langKey = _a.langKey, locale = _a.locale, onDelete = _a.onDelete, onResend = _a.onResend, loadAfterMessage = _a.loadAfterMessage, scrollToBottomFlag = _a.scrollToBottomFlag, changeScrollToBottomFlag = _a.changeScrollToBottomFlag, messageWithdraw = _a.messageWithdraw, reUpdateInputMessage = _a.reUpdateInputMessage, restProps = __rest(_a, ["isLoading", "messageList", "loadMore", "langKey", "locale", "onDelete", "onResend", "loadAfterMessage", "scrollToBottomFlag", "changeScrollToBottomFlag", "messageWithdraw", "reUpdateInputMessage"]);
        var elements = formatters
            .reduce(function (messageList, formatter) { return messageList.map(formatter); }, formatMessage(messageList, this.localeMerged))
            .map(function (i) { return (React.createElement(MessageItem, __assign({ key: i.messageId, message: i, locale: _this.localeMerged, langKey: langKey, onDelete: onDelete, onResend: onResend, messageWithdraw: messageWithdraw, reUpdateInputMessage: reUpdateInputMessage }, restProps))); });
        return (React.createElement(ChatList, { loadMore: loadMore, loadingSpinner: React.createElement(Icon, { type: "loading" }), isLoading: isLoading, elements: elements, className: "message-list", loadAfterMessage: loadAfterMessage, scrollToBottomFlag: scrollToBottomFlag, changeScrollToBottomFlag: changeScrollToBottomFlag }));
    };
    MessageContent.defaultProps = {
        langKey: "en",
        onDelete: function () { },
        onResend: function () { },
    };
    return MessageContent;
}(React.Component));
export default MessageContent;

//# sourceMappingURL=index.js.map
